// extracted by mini-css-extract-plugin
module.exports = {"linkGroupRow":"footer-link-group-row_linkGroupRow__VqnyM","fade-in":"footer-link-group-row_fade-in__hness"};